/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


var empColl = document.getElementsByClassName("appForm-collapse");
var i;

for (i = 0; i < empColl.length; i++) {
  empColl[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var appContent = this.nextElementSibling;
    if (appContent.style.maxHeight){
      appContent.style.maxHeight = null;
    } else {
      appContent.style.maxHeight = appContent.scrollHeight + "px";
    }
  });
}

var filtercoll = document.getElementsByClassName("filter-collapse");
var j;

for (j = 0; j < filtercoll.length; j++) {
  filtercoll[j].addEventListener("click", function() {
    this.classList.toggle("filter-active");
    var filcontent = this.nextElementSibling;
    if (filcontent.style.maxHeight){
      filcontent.style.maxHeight = null;
    } else {
      filcontent.style.maxHeight = filcontent.scrollHeight + "px";
    }
  });
}